import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { useTranslations } from '@lang';
import { Spinner } from '@common/components/Spinner';
import { ReduxFormInput } from '@common/components/FormElements/BlockInputField';
import { FormRow } from '@common/components/AuthLayout/Layout';
import Error from '@common/components/Error';
import { Button } from '@common/components';
import { required, validEmail } from '@utils/validators';

const validate = (values) => {
  const errors = {};

  errors.email = required(values.email) || validEmail(values.email);
  errors.password = required(values.password);

  return errors;
};

const SignInForm = ({ handleSubmit, submitting, pristine, loginError = null }) => {
  const { t } = useTranslations();

  return (
    <form onSubmit={handleSubmit} noValidate style={{ position: 'relative' }}>
      <Spinner showDelayMessage isActive={submitting} />
      {loginError && <Error error={{ code: loginError }} />}
      <FormRow>
        <Field
          component={ReduxFormInput}
          name="email"
          errorBottom
          data-testid="email"
          label={t('signIn.emailLabel')}
        />
      </FormRow>
      <FormRow>
        <Field
          component={ReduxFormInput}
          name="password"
          errorBottom
          type="password"
          data-testid="password"
          label={t('signIn.passwordLabel')}
        />
      </FormRow>
      <FormRow align="right" actionButtons>
        <Button type="submit" disabled={submitting || pristine} isPrimary testid="logIn">
          {t('signIn.login')}
        </Button>
      </FormRow>
    </form>
  );
};

SignInForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  loginError: PropTypes.string,
};

export default reduxForm({
  form: 'signInForm',
  pristine: true,
  validate,
})(SignInForm);
